module.exports = __webpack_public_path__ + "img/tab-discover-active.e02c7ce.png";